import axios from "axios";
import store from "../../redux/store";
import * as actions from "./LoginTypes";
import AppConsts from "../../appconst";
import { handleAxiosPost } from "../axiosHelper";

export const UserLogin = async (credentials, rememberMe) => {
  try {
    const data = new URLSearchParams();
    data.append("userName", credentials.userName);
    data.append("password", credentials.password);
    data.append("grant_type", "password");
    data.append("Type", "App");

    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${AppConsts.apiBaseUrl}/api/Login`,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      data: data,
    };

    const response = await axios.request(config);

    if (response.status === 200) {
      const parsedList = JSON.parse(response.data?.datas);
      const firstItem = parsedList[0] || {};

      localStorage.setItem("token", response.data?.access_token);
      localStorage.setItem("userName", response.data?.userName || "");
      localStorage.setItem("userCode", response.data?.userCode || "");
      localStorage.setItem("taxCode", firstItem?.TaxCode || "");
      localStorage.setItem("Whse", firstItem?.Whse || "");
      localStorage.setItem("Series", firstItem?.Series || "");
      localStorage.setItem("CCenter", firstItem?.CCenter || "");
      localStorage.setItem(
        "EnableMarktingTeamField",
        firstItem?.EnableMarktingTeamField === "Y" ? "true" : "false"
      );
      localStorage.setItem(
        "EnableFactoryTeamField",
        firstItem?.EnableFactoryTeamField === "Y" ? "true" : "false"
      );
      localStorage.setItem("Team", firstItem?.Team || "");
      localStorage.setItem("authenticated", true);

      let objType = "";
      switch (firstItem?.Series) {
        case "1518":
          objType = "17"; // Sales Order
          break;
        case "1517":
          objType = "23"; // Sales Quote
          break;
        default:
          objType = firstItem?.ObjType || "";
      }
      localStorage.setItem("ObjType", objType);

      if (rememberMe) {
        localStorage.setItem("rememberMe", "true");
        localStorage.setItem("savedUserName", credentials.userName);
      } else {
        localStorage.removeItem("rememberMe");
        localStorage.removeItem("savedUserName");
      }

      return { success: true, data: response.data };
    } else {
      return { success: false, msg: response.data.msg };
    }
  } catch (error) {
    return {
      success: false,
      msg: error.response ? error.response.data : error.message,
    };
  }
};

export const resetPassword = async (payload) => {
  const url = "/api/notifications/resetpassword";
  const contentType = "application/json";
  const data = payload;

  const { data: responseData } = await handleAxiosPost(url, contentType, data);

  if (responseData.result) {
    return responseData;
  } else {
    return responseData;
  }
};

export const CheckResetPasswordLink = async (payload) => {
  const url = "/api/notifications/CheckResetPasswordLink";
  const contentType = "application/json";
  const data = payload;

  const { data: responseData } = await handleAxiosPost(url, contentType, data);

  if (responseData.result) {
    return responseData;
  } else {
    return responseData;
  }
};

export const UserLogout = () => {
  localStorage.clear();
  window.location.reload();
};

export const GetAntiForgeryToken = async () => {
  try {
    var result = await axios({
      method: "get",
      url: AppConsts.apiBaseUrl + "/Login/GetToken",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        localStorage.setItem("X-Xsrf-Token", response.data);
        return response.data;
      })
      .catch((err) => {
        if (err?.response?.status == 401) {
          if (!logout) {
            logout = true;
            Modal.confirm({
              content: "Session expired, Please relogin.",
              cancelButtonProps: { hidden: true },
              onOk: () => {
                UserLogout();
              },
            });
          }
        }
        console.log({ content: err.message });
        result = "";
      });
    return result;
  } catch (err) {
    console.log({ content: err.message });
    return "";
  }
};
